
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaderboard",
      function () {
        return require("private-next-pages/leaderboard.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaderboard"])
      });
    }
  